/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StudentProfileAssignment } from '../../models/student-profile-assignment';

export interface GetStudentAssignments$Params {
  profileId: string;
}

export function getStudentAssignments(http: HttpClient, rootUrl: string, params: GetStudentAssignments$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<StudentProfileAssignment>>> {
  const rb = new RequestBuilder(rootUrl, getStudentAssignments.PATH, 'get');
  if (params) {
    rb.path('profileId', params.profileId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<StudentProfileAssignment>>;
    })
  );
}

getStudentAssignments.PATH = '/studentprofile/{profileId}/assignment';
